import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatCard } from '@angular/material/card';
import { MatRadioModule } from '@angular/material/radio';
import { ChangeDetectorRef } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  FormArray,
  FormControl,
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgToastService } from 'ng-angular-popup';
import { ProjectsService } from '@/app/services/projects/projects.service';
import { Router } from '@angular/router';
import { MatExpansionModule } from '@angular/material/expansion';
import { ApplicantPqqSectionsComponent } from '../applicant-pqq-sections.component';
import { environment } from '@/app/environments/environment';
import { GetFileIconUtilityService } from '@/app/services/utility/get-file-icon-utility.service';

import { FileManagerComponent } from '@/app/components/shared/file-manager/file-manager.component';
@Component({
  selector: 'app-safty-environment-management',
  standalone: true,
  imports: [
    MatExpansionModule,
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatCard,
    MatRadioModule,
    FileManagerComponent,
  ],
  templateUrl: './safty-environment-management.component.html',
  styleUrl: './safty-environment-management.component.css',
})
export class SaftyEnvironmentManagementComponent implements OnInit, OnChanges {
  @Input() applicantData: any;
  @Input() isEdit: boolean;
  @Input() isFetchApplicantData: boolean;
  pdfUrl: any;
  formGroup: FormGroup;
  base_path = environment.storageUrl;
  safetyAccrAttachments: any[] = [];
  envAccrAttachments: any[] = [];

  oldHealthAndSafetyPolicyFiles: any[] = [];
  oldEnvironmentalPolicyFiles: any[] = [];
  oldSafetyAccreditationsFiles: any[] = [];
  oldEnvironmentalAccreditationsFiles: any[] = [];
  oldSustainabilityFiles: any[] = [];

  deletedHealthAndSafetyPolicyFilesIds: any[] = [];
  deletedEnvironmentalPolicyFilesIds: any[] = [];
  deletedSafetyAccrAttachments: number[] = [];
  deletedEnvAccrAttachments: number[] = [];

  /**
   * NOTE: this is using the new files manager component. For old files,
   * they will be required to be updated using this component as well
   */
  deletedOldEnvironmentalPolicyFilesIds: any[] = [];
  deletedOldHealthAndSafetyPolicyFilesIds: any[] = [];
  deletedOldSafetyAccreditationsFilesIds: any[] = [];
  deletedOldEnvironmentalAccreditationsFilesIds: any[] = [];
  deletedOldSustainabilityFilesIds: any[] = [];

  constructor(
    private fb: FormBuilder,
    private toast: NgToastService,
    private projectsService: ProjectsService,
    private router: Router,
    private ApplicantPqqSectionsComponent: ApplicantPqqSectionsComponent,
    private cdr: ChangeDetectorRef,
    private getFileIconService: GetFileIconUtilityService
  ) {}

  ngOnInit(): void {
    this.formGroup = this.fb.group({
      // Health & safety
      has_health_policy: ['0'],
      health_incidents: ['0'],
      health_incident_details: [''],
      has_env_policy: ['0'],
      sustainability_initiatives: [''],

      healthAndSafetyPolicyFileControl: new FormArray([]),
      environmentalPolicyFileControl: new FormArray([]),
      safetyAccreditationsFileControl: new FormArray([]),
      environmentalAccreditationsFileControl: new FormArray([]),
      sustainabilityFileControl: new FormArray([]),
    });

    if (this.isEdit) {
      this.patchFormValues();
    }
  }

  onFileUpload(event: any, name: string) {
    const files = event.target.files;

    if (name === 'health_acc_attach') {
      if (files.length > 0) {
        for (let i = 0; i < files.length; i++) {
          this.safetyAccrAttachments.push(files[i]);
        }
      }
    } else {
      if (files.length > 0) {
        for (let i = 0; i < files.length; i++) {
          this.envAccrAttachments.push(files[i]);
        }
      }
    }
  }

  removeNewFile(index: number, name: string) {
    if (name === 'safety_accr_attach') {
      if (
        this.safetyAccrAttachments &&
        this.safetyAccrAttachments.length > index
      ) {
        this.safetyAccrAttachments.splice(index, 1);
      }
    }

    if (name === 'env_accr_attach') {
      if (this.envAccrAttachments && this.envAccrAttachments.length > index) {
        this.envAccrAttachments.splice(index, 1);
      }
    }
  }

  removeOldFile(index: number, id: number, name: string) {
    if (name === 'safety_accr_attach') {
      if (
        this.oldSafetyAccreditationsFiles &&
        this.oldSafetyAccreditationsFiles.length > index
      ) {
        this.oldSafetyAccreditationsFiles.splice(index, 1);
        this.deletedOldSafetyAccreditationsFilesIds.push(id);
      }
    }

    if (name === 'env_accr_attach') {
      if (
        this.oldEnvironmentalAccreditationsFiles &&
        this.oldEnvironmentalAccreditationsFiles.length > index
      ) {
        this.oldEnvironmentalAccreditationsFiles.splice(index, 1);
        this.deletedOldEnvironmentalAccreditationsFilesIds.push(id);
      }
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['isFetchApplicantData'] &&
      !changes['isFetchApplicantData'].firstChange
    ) {
      this.patchFormValues();
    }
  }

  patchFormValues() {
    this.formGroup.patchValue({
      has_health_policy: String(this.applicantData?.has_health_policy || '0'),
      health_incidents: String(this.applicantData?.health_incidents || '0'),
      health_incident_details:
        this.applicantData?.health_incident_details || '',
      has_env_policy: String(this.applicantData?.has_env_policy || '0'),
      sustainability_initiatives:
        this.applicantData?.sustainability_initiatives || '',
    });

    this.oldSafetyAccreditationsFiles =
      this.applicantData?.parent_document.filter(
        (doc) => doc.type === 'safety_accr_attach'
      ) || [];
    this.oldEnvironmentalAccreditationsFiles =
      this.applicantData?.parent_document.filter(
        (doc) => doc.type === 'env_accr_attach'
      ) || [];
    this.oldHealthAndSafetyPolicyFiles =
      this.applicantData?.parent_document.filter(
        (doc) => doc.type === 'health_safety_policy_attach'
      ) || [];
    this.oldEnvironmentalPolicyFiles =
      this.applicantData?.parent_document.filter(
        (doc) => doc.type === 'environmental_policy_attach'
      ) || [];

    this.addOldAttachmentMapping(this.applicantData);

    this.cdr.detectChanges();
  }
  openPdf(): void {
    window.open(this.pdfUrl, '_blank');
  }

  isImageFile(file: any) {
    // List of image file extensions
    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'];
    let fileExtension: any;
    // Extract the file extension from the file's name (not from preview)
    if (this.isEdit && !file?.name) {
      fileExtension = file?.split('.').pop()?.toLowerCase();
    } else if (this.isEdit && file?.name) {
      fileExtension = file?.name?.split('.').pop()?.toLowerCase();
    } else {
      fileExtension = file?.name?.split('.').pop()?.toLowerCase();
    }

    // Check if the extension is in the list of image extensions
    return imageExtensions.includes(fileExtension || '');
  }

  handleBack() {
    this.ApplicantPqqSectionsComponent.previousStep();
  }

  prepareDataToSubmit() {
    const dataToSubmit = new FormData();

    // Dynamically append all form controls to FormData
    Object.keys(this.formGroup.controls).forEach((key) => {
      const value = this.formGroup.get(key)?.value;
      if (value !== null && value !== undefined && value !== '') {
        dataToSubmit.append(key, value);
      }
    });

    // if (this.safetyAccrAttachments?.length) {
    //   this.safetyAccrAttachments.forEach((file: File) => {
    //     dataToSubmit.append('safety_accr_attach[]', file);
    //   });
    // }

    // if (this.envAccrAttachments?.length) {
    //   this.envAccrAttachments.forEach((file: File) => {
    //     dataToSubmit.append('env_accr_attach[]', file);
    //   });
    // }

    // Files handling Start
    this.addUploadedFiles(
      dataToSubmit,
      'healthAndSafetyPolicyFileControl',
      this.formGroup,
      'health_safety_policy_attach'
    );
    this.addUploadedFiles(
      dataToSubmit,
      'environmentalPolicyFileControl',
      this.formGroup,
      'environmental_policy_attach'
    );
    this.addUploadedFiles(
      dataToSubmit,
      'safetyAccreditationsFileControl',
      this.formGroup,
      'safety_accr_attach'
    );
    this.addUploadedFiles(
      dataToSubmit,
      'environmentalAccreditationsFileControl',
      this.formGroup,
      'env_accr_attach'
    );
    this.addUploadedFiles(
      dataToSubmit,
      'sustainabilityFileControl',
      this.formGroup,
      'sustainability_initiatives_attach'
    );

    this.addDeletedOldFilesIds(dataToSubmit);
    // Files handling End

    dataToSubmit.append('is_update', this.isEdit ? 'true' : 'false');

    return dataToSubmit;
  }

  addUploadedFiles(
    submissionFormData: FormData,
    controlName: string,
    formGroup: FormGroup,
    formFieldName: string
  ) {
    if (formGroup.value[controlName]) {
      formGroup.value[controlName].forEach((uploadedFile: File) => {
        if (uploadedFile) {
          submissionFormData.append(`${formFieldName}[]`, uploadedFile);
        }
      });
    }
  }

  // NOTE: on submit, we append deleted files ids into data
  addDeletedOldFilesIds(submissionFormData) {
    if (this.deletedOldHealthAndSafetyPolicyFilesIds?.length > 0) {
      submissionFormData.append(
        'deleted_health_safety_policy_attach_ids',
        JSON.stringify(this.deletedHealthAndSafetyPolicyFilesIds)
      );
    }

    if (this.deletedOldEnvironmentalPolicyFilesIds?.length > 0) {
      submissionFormData.append(
        'deleted_environmental_policy_attach_ids',
        JSON.stringify(this.deletedEnvironmentalPolicyFilesIds)
      );
    }

    if (this.deletedOldSafetyAccreditationsFilesIds?.length > 0) {
      submissionFormData.append(
        'deleted_safety_accr_attach_ids',
        JSON.stringify(this.deletedOldSafetyAccreditationsFilesIds)
      );
    }
    if (this.deletedOldEnvironmentalAccreditationsFilesIds?.length > 0) {
      submissionFormData.append(
        'deleted_env_accr_attach_ids',
        JSON.stringify(this.deletedOldEnvironmentalAccreditationsFilesIds)
      );
    }
    if (this.deletedOldSustainabilityFilesIds?.length > 0) {
      submissionFormData.append(
        'deleted_sustainability_attach_ids',
        JSON.stringify(this.deletedOldSustainabilityFilesIds)
      );
    }
  }

  onSubmit(): void {
    // this.toast.success('Pre Qualification submitted', 'SUCCESS');
    if (this.formGroup.valid) {
      const dataToSubmit = this.prepareDataToSubmit();
      this.projectsService.projectPQQResponseStep2(dataToSubmit).subscribe({
        next: () => {
          this.toast.success('Pre Qualification submitted', 'SUCCESS');
          this.ApplicantPqqSectionsComponent.nextStep();
        },
        error: (error: any) => {
          console.error('Failed to submit:', error);
          this.toast.danger(error.error.message, 'DANGER', 4000);
        },
      });
    } else {
      this.toast.warning('Please fill the required fields', 'WARNING');
      this.formGroup.markAllAsTouched(); // Highlights all invalid fields
    }
  }

  getFileIcon(file: {
    file: File;
    preview: string;
    id?: number;
    name?: string;
  }): string {
    return this.getFileIconService.getFileIcon(file);
  }

  // NOTE: on edit, we add old files to the form array
  addOldAttachmentMapping(response) {
    if (response.sustainability_initiative_attach) {
      this.oldSustainabilityFiles =
        response.sustainability_initiative_attach || [];
    }
  }

  /**
   * Handling File Operations - START
   */
  handleNewFiles(filesData: {
    files: File[];
    controlName: string;
    isEmpty: boolean;
  }) {
    console.log('filesData', filesData);
    const fileArray = this.formGroup.get(filesData.controlName) as FormArray;
    if (!fileArray) {
      return;
    }
    fileArray.clear();
    // If no files are present, we break
    if (filesData.isEmpty) {
      return;
    }

    filesData.files.forEach((file) => fileArray.push(new FormControl(file)));
  }

  // Uploading/Deleting new files for site preparation
  handleDeletedOldFiles(OldFileData: any) {
    const controlName = OldFileData.controlName;
    const fileId = OldFileData?.file?.id;

    if (!fileId || !controlName) return;

    // Remove 'FileControl' from the controlName dynamically
    const baseName = controlName.replace('FileControl', '');

    // Construct dynamic deleted file IDs array name
    const deletedFileIdsKey = `deletedOld${this.capitalizeFirstLetter(
      baseName
    )}FilesIds`;
    const oldFilesKey = `old${this.capitalizeFirstLetter(baseName)}Files`;

    console.log('deletedFileIdsKey', deletedFileIdsKey);
    console.log('oldFilesKey', oldFilesKey);

    // Ensure the deleted file IDs array exists before pushing
    if (!this[deletedFileIdsKey]) {
      this[deletedFileIdsKey] = [];
    }
    this[deletedFileIdsKey].push(fileId);

    // Ensure the old files array exists before filtering
    if (this[oldFilesKey]) {
      this[oldFilesKey] = this[oldFilesKey].filter(
        (file) => file.id !== fileId
      );
    }
  }

  // Utility function to capitalize the first letter
  capitalizeFirstLetter(string: string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  /**
   * Handling File Operations - END
   */
}
